import type { SVGProps } from "react";
export const Tiktok = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M17.7494 8.38152C16.2013 8.38522 14.6911 7.90241 13.4322 7.00129V13.286C13.4318 14.45 13.076 15.5861 12.4124 16.5425C11.7489 17.4988 10.8092 18.2298 9.71896 18.6376C8.62876 19.0455 7.44002 19.1108 6.3117 18.8248C5.18338 18.5388 4.16926 17.9152 3.40495 17.0373C2.64063 16.1594 2.16255 15.069 2.03463 13.9121C1.90671 12.7551 2.13504 11.5867 2.68911 10.563C3.24317 9.53937 4.09655 8.70924 5.13514 8.18367C6.17373 7.65809 7.34801 7.46212 8.50099 7.62195V10.7829C7.97338 10.617 7.40683 10.622 6.88224 10.7972C6.35765 10.9725 5.90185 11.309 5.57992 11.7587C5.25799 12.2085 5.0864 12.7484 5.08966 13.3015C5.09292 13.8546 5.27085 14.3925 5.59806 14.8384C5.92526 15.2843 6.385 15.6155 6.91162 15.7845C7.43824 15.9536 8.00481 15.9519 8.53042 15.7797C9.05603 15.6076 9.5138 15.2737 9.83836 14.8259C10.1629 14.378 10.3377 13.8391 10.3377 13.286V1H13.4322C13.43 1.26133 13.4519 1.5223 13.4976 1.77961C13.6051 2.35403 13.8287 2.90047 14.1547 3.38551C14.4806 3.87055 14.9021 4.284 15.3934 4.60056C16.0922 5.06266 16.9116 5.30896 17.7494 5.30879V8.38152Z"
			fill="currentColor"
		/>
	</svg>
);
